import { connect } from 'react-redux';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { getCustomerCard } from '../../customer/selectors';
import { getCard } from '../reducer/card/selectors';
import CardSelected from '../components/CardSelected';
import { setCard } from '../reducer/card/actions';
import { setCard as customerSetCard } from '../../customer/actions';

const CardSelectedContainer = compose(
  connect(
    state => ({
      card: getCustomerCard(state) || getCard(state),
    }),
    { setCard, customerSetCard }
  ),
  withHandlers({
    changeCard: props => () => {
      props.setCard();
      props.customerSetCard();
    },
  }),
  branch(props => !props.card, renderNothing)
)(CardSelected);

export default CardSelectedContainer;
